// material ui
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import Avatar from '@mui/material/Avatar';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Chip from '@mui/material/Chip';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import EmailIcon from '@mui/icons-material/Email';
import Stack from '@mui/material/Stack';
import Checkbox from '@mui/material/Checkbox';

// project imports
import formateBoolean, { getStatusLabel, getStatusColor, getStatusIcon } from 'utils/Functions/commonFunction';

// third-party
import SyncLoader from 'react-spinners/SyncLoader';
import { Edit, PunchClock } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { MenuItem, Select, Switch } from '@mui/material';

// ==============================|| Table ||============================== //
const statusOptions = ['active', 'deactive', 'inprocess', 'resolved', 'paused'];

const CustomTable = ({
    hideDelete,
    columns,
    loading,
    data,
    totalCount,
    rowsPerPage,
    page,
    handleChangePage,
    handleChangeRowsPerPage,
    onClickDelete,
    onClickView,
    type,
    noEdit,
    isView,
    onClickEdit,
    onChangeHandler,
    refetch,
    onClickRefetch,
    onChangeEmailSubscription,
    onChangeRecruiterAccess,
    onChangeFeedbackStatus,
    addFeedback,
    onFeedbackModalHandler
}) => {
    const everyElmisChecked = data?.every((i) => i.checked);
    const { t } = useTranslation();

    const getTime = (date) => {
        let result = moment(date).fromNow();
        const now = moment();
        const days = now.diff(date, 'days');
        const weeks = now.diff(date, 'weeks');
        if (days >= 7) {
            if (days <= 13) {
                result = `a week ago`;
            } else if (days > 13 && days <= 25) {
                result = `${weeks} weeks ago`;
            }
        }
        return result;
    };

    return (
        <>
            <TableContainer sx={{ maxHeight: 440 }}>
                <Table aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns?.map((column) => (
                                <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                    {column?.hasCheckBox && <Checkbox value={everyElmisChecked} />} {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    {loading && (
                        <TableBody>
                            <TableRow>
                                <TableCell colSpan={6}>
                                    <SyncLoader
                                        color="#5e35b1"
                                        css={{ display: 'flex', justifyContent: 'center' }}
                                        loading={loading}
                                        size={15}
                                    />
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    )}

                    <TableBody>
                        {!loading &&
                            data?.map((row) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                        {columns.map((column) => {
                                            const value = row[column.id];
                                            if (column.id === 'status' && addFeedback) {
                                                return (
                                                    <TableCell key={column.id} align={column.align}>
                                                        <Select
                                                            value={row.status}
                                                            onChange={(e) => onChangeFeedbackStatus(row.id, e.target.value)}
                                                        >
                                                            {statusOptions.map((option) => (
                                                                <MenuItem key={option} value={option}>
                                                                    {option}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </TableCell>
                                                );
                                            }
                                            if (column.id === 'feedback' && addFeedback) {
                                                return (
                                                    <TableCell key={column.id} align={column.align}>
                                                        <div className="desc">{row?.feedback}</div>
                                                    </TableCell>
                                                );
                                            }
                                            if (column.id === 'status') {
                                                return (
                                                    <TableCell key={column.id} align={column.align}>
                                                        <Chip
                                                            label={t(getStatusLabel(value))}
                                                            variant="outlined"
                                                            color={getStatusColor(value)}
                                                            size="small"
                                                            deleteIcon={getStatusIcon(value)}
                                                            onDelete={() => null}
                                                        />
                                                    </TableCell>
                                                );
                                            }

                                            if (column.id === 'user') {
                                                return (
                                                    <TableCell key={column.id} align={column.align}>
                                                        <span>{value?.full_name}</span>
                                                    </TableCell>
                                                );
                                            }

                                            if (column.id === 'createdAt') {
                                                return (
                                                    <TableCell key={column.id} align={column.align}>
                                                        <span>
                                                            {getTime(value)} ( {moment(value).format('DD MMM YYYY')} )
                                                        </span>
                                                    </TableCell>
                                                );
                                            }

                                            if (column.id === 'lastLogin') {
                                                return (
                                                    <TableCell key={column.id} align={column.align}>
                                                        {!value && <span>N/A</span>}
                                                        {value && (
                                                            <span>
                                                                {getTime(value)} ( {moment(value).format('DD MMM YYYY')} )
                                                            </span>
                                                        )}
                                                    </TableCell>
                                                );
                                            }

                                            if (column?.type === 'image') {
                                                return (
                                                    <TableCell key={column.id} align={column.align}>
                                                        <Avatar alt="Baysten" src={process.env.REACT_APP_SERVER_URL + value} />
                                                    </TableCell>
                                                );
                                            }

                                            if (column.id === 'email_subscription') {
                                                return (
                                                    <TableCell key={column.id} align={column.align}>
                                                        <Switch
                                                            checked={value === 0 ? true : false}
                                                            onChange={(e) => onChangeEmailSubscription(e, row)}
                                                        />
                                                    </TableCell>
                                                );
                                            }

                                            if (column.id === 'recruiter') {
                                                const isRecruiter = row?.features?.find((i) => i === 'RECRUITER_FULL_ACCESS');
                                                return (
                                                    <TableCell key={column.id} align={column.align}>
                                                        <Switch
                                                            checked={isRecruiter}
                                                            onChange={() => onChangeRecruiterAccess(isRecruiter, row)}
                                                        />
                                                    </TableCell>
                                                );
                                            }

                                            if (column.id === 'action') {
                                                return (
                                                    <TableCell key={column.id} align={column.align}>
                                                        <Stack direction="row" spacing={2}>
                                                            {refetch && (
                                                                <Button
                                                                    color="inherit"
                                                                    onClick={(e) => onClickRefetch(e, row, 'update')}
                                                                    variant="outlined"
                                                                    startIcon={<PunchClock />}
                                                                >
                                                                    {t('Refetch')}
                                                                </Button>
                                                            )}
                                                            {type === 'country' && addFeedback && (
                                                                <Button
                                                                    color="inherit"
                                                                    onClick={() => onFeedbackModalHandler(row?.id)}
                                                                    variant="outlined"
                                                                    startIcon={<EmailIcon />}
                                                                >
                                                                    {t('Mail')}
                                                                </Button>
                                                            )}
                                                            {!hideDelete && (
                                                                <Button
                                                                    color="error"
                                                                    onClick={() => onClickDelete(row)}
                                                                    variant="outlined"
                                                                    startIcon={<DeleteIcon />}
                                                                >
                                                                    {t('Delete')}
                                                                </Button>
                                                            )}
                                                            {type === 'country' && !noEdit && (
                                                                <Button
                                                                    color="inherit"
                                                                    onClick={(e) => onClickEdit(e, row, 'update')}
                                                                    variant="outlined"
                                                                    startIcon={<Edit />}
                                                                >
                                                                    {t('Edit')}
                                                                </Button>
                                                            )}
                                                            {type !== 'country' && !noEdit && (
                                                                <Button
                                                                    color="inherit"
                                                                    onClick={() => onClickView(row)}
                                                                    variant="outlined"
                                                                    startIcon={<VisibilityOutlinedIcon />}
                                                                >
                                                                    {t('View')}
                                                                </Button>
                                                            )}
                                                            {type === 'country' && isView && (
                                                                <Button
                                                                    color="inherit"
                                                                    onClick={() => onClickView(row)}
                                                                    variant="outlined"
                                                                    startIcon={<VisibilityOutlinedIcon />}
                                                                >
                                                                    {t('View')}
                                                                </Button>
                                                            )}
                                                        </Stack>
                                                    </TableCell>
                                                );
                                            }

                                            return (
                                                <TableCell key={column.id} align={column.align}>
                                                    {column?.hasCheckBox && (
                                                        <Checkbox value={row?.checked} onChange={(e) => onChangeHandler(row.id, e)} />
                                                    )}
                                                    {typeof value === 'boolean' ? formateBoolean(value) : value}
                                                </TableCell>
                                            );
                                        })}
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={totalCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </>
    );
};

export default CustomTable;
